<template>
    <PageView>
        <a-card title="列表">
            <a-button type="primary" slot="extra" @click="$router.push({ name: `addprovider` })">添加小程序</a-button>
            <a-row :gutter="10" class="inputGroup">
                <a-col :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.jump_url" placeholder="跳转地址" @keyup.enter="getListTwo" />
                </a-col>
                <a-col  :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.name" placeholder="小程序名称" @keyup.enter="getListTwo" />
                </a-col>
                <a-col  :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.app_id" placeholder="小程序ID" @keyup.enter="getListTwo" />
                </a-col>
                <a-col :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.code" placeholder="数据源码" @keyup.enter="getListTwo" />
                </a-col>
                <a-col :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.temple_code" placeholder="首页banner样式" @keyup.enter="getListTwo" />
                </a-col>
                <a-col :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.shop_name" placeholder="主体名称" @keyup.enter="getListTwo" />
                </a-col>
                <a-col :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.shop_account" placeholder="主体账号" @keyup.enter="getListTwo" />
                </a-col>
                <a-col  :xs="10" :md="4" :lg="4" :xl="2">
                    <a-select v-model="searchData.is_open_url" placeholder="跳转状态" style="width: 120px" allowClear>
                        <a-select-option :value="1">关闭</a-select-option>
                        <a-select-option :value="2">开启</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
                    <a-select v-model="searchData.is_jump_global" placeholder="全局状态" style="width: 100%" allowClear>
                        <a-select-option :value="1">关闭</a-select-option>
                        <a-select-option :value="2">开启</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
                    <a-select v-model="searchData.is_h5_jump" placeholder="H5状态" style="width: 100%" allowClear>
                        <a-select-option :value="1">关闭</a-select-option>
                        <a-select-option :value="2">开启</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
                    <a-select v-model="searchData.is_jietu" placeholder="首页展示模式" style="width: 100%" allowClear>
                        <a-select-option :value="1">正常模式</a-select-option>
                        <a-select-option :value="2">截图模式</a-select-option>
                        <a-select-option :value="3">额度测算模式</a-select-option>
                        <a-select-option :value="4">计算器模式</a-select-option>
                        <a-select-option :value="5">比价模式</a-select-option>
                        <a-select-option :value="6">租超(拿手机号)模式</a-select-option>
                        <a-select-option :value="7">租超(直跳)模式</a-select-option>
                        <a-select-option :value="8">会展服务模式</a-select-option>
                        <a-select-option :value="9">3C数码维修模式</a-select-option>
                        <a-select-option :value="10">租机咨询(资讯)模式</a-select-option>
                        <a-select-option :value="11">网页模式</a-select-option>
                        <a-select-option :value="12">宝宝起名模式</a-select-option>
                        <a-select-option :value="13">个税计算神器</a-select-option>
                        <a-select-option :value="14">退休金计算神器</a-select-option>
                        <a-select-option :value="15">菜谱大全</a-select-option>
                        <a-select-option :value="16">开销记账神器</a-select-option>
                        <a-select-option :value="17">手机查询神器</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="10" :md="4" :lg="4" :xl="2">
                    <a-input v-model="searchData.version" placeholder="版本号" @keyup.enter="getListTwo" />
                </a-col>
                <a-col :xs="10" :md="4" :lg="4" :xl="2">
                    <a-select v-model="searchData.is_robot_checking" placeholder="机器人巡检" style="width: 120px" allowClear>
                        <a-select-option :value="1">关闭</a-select-option>
                        <a-select-option :value="2">开启</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="search-buttons">
                    <a-button type="primary" :loading="loading" @click="getListTwo">
                        <a-icon type="search" />确定筛选
                    </a-button>
                    <a-button type="default" style="margin-left: 8px" :loading="loading" @click="getListInit">
                        <a-icon type="reload" />重置
                    </a-button>
                    <a-button type="danger" style="margin-left: 8px" :loading="loading" @click="clearCache">
                        <a-icon type="delete" />清除缓存
                    </a-button>
                </a-col>
            </a-row>
            <a-table
                :loading="loading"
                :columns="columns"
                :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }"
                @change="changePagination"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
        </a-card>

        <a-modal v-model="visible" title="Basic Modal" @ok="visible = false">
            <img :src="viewImg" style="width: 100%;" alt="" />
        </a-modal>
        <a-modal title="查看图片" :visible="ISimg" centered :closable="false" :maskClosable="false" width="600px">
            <img :src="imgUrl" alt="" style="width: 100%;height: 100%" />
            <template slot="footer">
                <a-button-group>
                    <a-button type="primary" @click="ISimg = false">确定</a-button>
                    <a-button type="default" @click="ISimg = false">关闭</a-button>
                </a-button-group>
            </template>
        </a-modal>
    </PageView>
</template>

<script type="text/jsx">
import Shop from '../../api/Shop.js'
var moment = require('moment')
export default {
    name: 'dealList',
    data () {
        return {
            loading: true,
            ISimg: false,
            imgUrl:'',
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                },
                {
                    title: '小程序名称',
                    dataIndex: 'name',
                },
                {
                    title: '小程序ID',
                    dataIndex: 'app_id',
                },
                {
                    title: '版本号及版本状态',
                    dataIndex: 'version',
                },
                {
                    title: '数据源码',
                    dataIndex: 'code',
                },
                {
                    title: '跳转状态',
                    dataIndex: 'is_open_url',
                    customRender: (text, record) => {
                        return (
                            <a-switch
                                checked={text === 2}
                                onChange={(checked) => this.handleStatusChange(checked, record.id, 'is_open_url')}
                                checkedChildren="外跳"
                                unCheckedChildren="不外跳"
                                style={{
                                    backgroundColor: text === 2 ? '#1890ff' : undefined
                                }}
                            />
                        )
                    }
                },
                {
                    title: '全局状态',
                    dataIndex: 'is_jump_global',
                    customRender: (text, record) => {
                        return (
                            <a-switch
                                checked={text === 2}
                                onChange={(checked) => this.handleStatusChange(checked, record.id, 'is_jump_global')}
                                checkedChildren="全局跳转"
                                unCheckedChildren="只点击跳转"
                                style={{
                                    backgroundColor: text === 2 ? '#1890ff' : undefined
                                }}
                            />
                        )
                    }
                },
                {
                    title: 'h5状态',
                    dataIndex: 'is_h5_jump',
                    customRender: (text, record) => {
                        return (
                            <a-switch
                                checked={text === 2}
                                onChange={(checked) => this.handleStatusChange(checked, record.id, 'is_h5_jump')}
                                checkedChildren="开"
                                unCheckedChildren="关"
                                style={{
                                    backgroundColor: text === 2 ? '#1890ff' : undefined
                                }}
                            />
                        )
                    }
                },
                {
                    title: '首页展示模式',
                    dataIndex: 'is_jietu',
                    customRender: (text, record) => {
                        const modeMap = {
                            1: '正常',
                            2: '截图',
                            3: '额度测算',
                            4: '计算器',
                            5: '比价',
                            6: '租超(拿手机号)',
                            7: '租超(直跳)',
                            8: '会展服务',
                            9: '3C数码维修',
                            10: '租机咨询(资讯)',
                            11: '网页模式',
                            12: '宝宝起名',
                            13: '个税计算神器',
                            14: '退休金计算神器',
                            15: '菜谱大全',
                            16: '开销记账神器',
                            17: '手机查询神器',
                        };
                        return (
                            <a-select
                                value={text}
                                style={{ width: '120px' }}
                                onChange={(value) => this.handleModeChange(value, record.id, 'is_jietu')}
                            >
                                {Object.keys(modeMap).map(key => (
                                    <a-select-option key={key} value={parseInt(key)}>
                                        {modeMap[key]}
                                    </a-select-option>
                                ))}
                            </a-select>
                        );
                    }
                },
        
                {
                    title: '主体名称',
                    dataIndex: 'shop_name',
                },
                {
                    title: '主体账号',
                    dataIndex: 'shop_account',
                },
                {
                    title: '首页banner样式',
                    dataIndex: 'temple_code',
                },

                {
                    title: '跳转地址',
                    dataIndex: 'jump_url',
                },

                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-button-group>
                                <a-button
                                    type="primary"
                                    onClick={()=>{
                                        this.$router.push({name:`addprovider`,query: { id: v.id}})
                                    }}>
                                    编辑小程序
                                </a-button>
                                <a-button
                                    type="danger"
                                    onClick={()=>{
                                        this.changeConfig(v.id)
                                    }}>
                                    删除
                                </a-button>
                            </a-button-group>
                        )

                    }
                }
            ],
            data: [],

            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            searchData: {
                name: '',
                app_id: '',
                is_open_url: undefined,
                is_robot_checking: undefined,
            },
            time: [],
            visible: false,
            viewImg: '',
            timeRange: [],
            newTime:[],
        }
    },
    activated () {
        this.getList()
    },
    methods: {
        handleRangeChange(value) {
            if (Array.isArray(value) && value.length === 2) {
                const validDates = value.every(date => date instanceof moment || date instanceof Date);
                if (validDates) {
                    this.timeRange = value;
                    const startTimeStamp = moment(this.timeRange[0]).valueOf();
                    const endTimeStamp = moment(this.timeRange[1]).valueOf();
                    this.newTime = [parseInt(startTimeStamp/1000),parseInt(endTimeStamp/1000)]
                    this.getList(this.newTime)
                }
            } else {
                this.newTime =[];
                this.getList(this.newTime)
            }

        },
        getListInit(){
            this.searchData.loginname = ''
            this.searchData.name = ''
            this.current = 1
            this.getList()
        },
        changeConfig (id) {
            this.$confirm({
                title: `删除`,
                content: `确定要删除吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Shop.Deleteprovider({
                            id: id
                        }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },

        clearCache (id) {
            this.$confirm({
                title: `清除所有缓存`,
                content: `确定要清除的所有缓存吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Shop.ClearCache({
                            id: id
                        }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },

        getListTwo () {
            this.current = 1
            this.getList()
        },
        getList (time) {
            this.loading = true
            Shop.providerList({
                page: this.current,
                num: this.pageSize,
                ...this.searchData,
                time:time
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key }
                })
                this.loading = false
                this.total = parseInt(res.count)
            })
        },
        changePagination (pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getList()
        },
        handleStatusChange(checked, id, field) {
            const status = checked ? 2 : 1  // 2表示开启（蓝色），1表示关闭（灰色）
            this.loading = true
            Shop.UpdateProviderStatus({
                id: id,
                [field]: status
            }).then(res => {
                if (res.status == 1) {
                    // 立即更新当前行的数据
                    const index = this.data.findIndex(item => item.id === id)
                    if (index !== -1) {
                        this.$set(this.data, index, {
                            ...this.data[index],
                            [field]: status
                        })
                    }
                }
            }).catch(err => {
                this.$message.error('跳转状态更新失败')
            }).finally(() => {
                this.loading = false
            })
        },
        handleModeChange(value, id, field) {
            this.loading = true;
            Shop.UpdateProviderStatus({
                id: id,
                [field]: value
            }).then(res => {
                if (res.status == 1) {
                    // 立即更新当前行的数据
                    const index = this.data.findIndex(item => item.id === id);
                    if (index !== -1) {
                        this.$set(this.data, index, {
                            ...this.data[index],
                            [field]: value
                        });
                    }
                }
            }).catch(err => {
                this.$message.error('模式更新失败');
            }).finally(() => {
                this.loading = false;
            });
        },
    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}

.search-buttons {
    text-align: right;
    margin-top: 16px;
    padding-right: 16px;
}

.ant-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 90px;

    .anticon {
        margin-right: 4px;
    }
}
</style>
